import React from 'react';
import Button from '../buttons/Button';

const TableActions = ({ tableActions, selectedRowCount, onTableAction }) => {
  return (
    <div style={{ display: 'flex', gap: 12 }}>
      {tableActions && tableActions.add && tableActions.add.action && (
        <Button onClick={() => onTableAction('add')}>
          {tableActions.add.title || 'Add'}
        </Button>
      )}
      {tableActions && tableActions.delete && tableActions.delete.action && (
        <Button
          onClick={() => onTableAction('delete')}
          disabled={selectedRowCount === 0}
        >
          {tableActions.delete.title || 'Delete Selected'}
        </Button>
      )}
    </div>
  );
};

export default TableActions;
